class SwatchImageSwap {
  constructor() {
    this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
    console.log('✅ SwatchImageSwap initialized. Mobile:', this.isMobile);
    this.init();
  }

  init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setupSwatches());
    } else {
      this.setupSwatches();
    }
  }

  setupSwatches() {
    const productCards = document.querySelectorAll('.product-card-wrapper');
    console.log('📦 Found product cards:', productCards.length);

    productCards.forEach((card, index) => {
      const swatches = card.querySelectorAll('.swatch-link[data-variant-image]');
      const productImage = card.querySelector('.card__media img');

      console.log(
        `Card ${index + 1}: Swatches=${swatches.length}, HasImage=${!!productImage}`
      );

      if (!productImage || swatches.length === 0) return;

      const originalSrc = productImage.currentSrc || productImage.src;
      const originalSrcset = productImage.srcset;
      let selectedSwatch = null;

      swatches.forEach((swatch, swatchIndex) => {
        const variantImage = swatch.getAttribute('data-variant-image');
        console.log(
          `  Swatch ${swatchIndex + 1}: ${variantImage ? 'HAS IMAGE' : 'NO IMAGE'}`
        );

        if (!variantImage || variantImage === '') return;

        if (this.isMobile) {
          swatch.addEventListener('click', (e) => {
            if (selectedSwatch === swatch) return;
            e.preventDefault();
            console.log('📱 Mobile tap detected. Swapping to:', variantImage);
            this.swapImage(productImage, variantImage);
            swatches.forEach((s) => s.classList.remove('swatch-selected'));
            swatch.classList.add('swatch-selected');
            selectedSwatch = swatch;
          });
        } else {
          swatch.addEventListener('mouseenter', () => {
            console.log('🖱️ Desktop hover detected. Swapping to:', variantImage);
            this.swapImage(productImage, variantImage);
          });

          swatch.addEventListener('mouseleave', () => {
            if (!selectedSwatch) {
              console.log('↩️ Swatch mouseleave – reverting to original');
              this.swapImage(productImage, originalSrc, originalSrcset);
            }
          });

          swatch.addEventListener('click', (e) => {
            // Don’t navigate away; just “lock in” the color visually.
            e.preventDefault();
            console.log('✅ Swatch clicked – locking selection:', variantImage);
            selectedSwatch = swatch;
          });
        }
      });

      if (!this.isMobile) {
        card.addEventListener('mouseleave', () => {
          if (!selectedSwatch) {
            console.log('↩️ Card mouseleave – reverting to original');
            this.swapImage(productImage, originalSrc, originalSrcset);
          }
        });
      }
    });
  }

  /**
   * Swap the main product image to a new source.
   * We must update BOTH src and srcset, otherwise the browser
   * will keep showing the old image because srcset has priority.
   */
  swapImage(imageElement, newSrc, newSrcset = null) {
    if (!imageElement || !newSrc) return;

    console.log('🔄 Swapping image element to:', newSrc);

    // Small fade effect
    imageElement.style.transition = 'opacity 0.2s ease';
    imageElement.style.opacity = '0.6';

    setTimeout(() => {
      // Update src and srcset
      imageElement.src = newSrc;
      imageElement.srcset = newSrcset || newSrc;

      // Force browser to re-evaluate the chosen resource
      imageElement.loading = 'eager';

      imageElement.onload = () => {
        imageElement.style.opacity = '1';
      };
    }, 100);
  }
}

new SwatchImageSwap();
